export function ViewLoading() {

  return (
    <div className="flex items-center justify-center h-screen">
      <img src="/logo.png" alt="logo" className="h-[35px] animate-pulse" />
    </div>
  )
}